export default __webpack_public_path__ + "static/media/12_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3607.e06d9339.jpg";